const DEBUG_NAVIGATION = import.meta.env.VITE_DEBUG_NAVIGATION === "true";

export const debugLog = (component: string, message: string, ...args: unknown[]) => {
  if (DEBUG_NAVIGATION) {
    console.log(`[${component}] ${message}`, ...args);
  }
};

export const debugError = (component: string, message: string, error: unknown) => {
  if (DEBUG_NAVIGATION) {
    console.error(`[${component}] ${message}`, error);
  }
};
